import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, setDisplayName } from 'recompose';

import { injectIntl } from 'components';
import { FRInput } from 'elements';

import { formatPrice } from 'helpers/utils';
import { isEmpty } from 'lodash';

export const getTotalPrice = ({
  data,
  deliveryFeeOrdered,
  defaultDeliveryFee,
  defaultDiscount,
}) => {
  const deliveryFee = deliveryFeeOrdered ? 0 : defaultDeliveryFee;
  const discountRate = (100 - defaultDiscount) / 100;
  let gross = 0;

  if (data.length) {
    data.forEach((item) => {
      gross += item.qty * item.price;
    });
  }

  return (gross  + deliveryFee).toFixed(2);
};

const totalDueColStyle = { width: 65, display: 'inline-block', fontSize: 18 };

class BottomPanel extends Component {
  static contextTypes = {
    isPublic: PropTypes.bool,
    isConsumer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    currentUser: PropTypes.shape({}),
  };

  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({}),
    ),
    defaultDiscount: PropTypes.number.isRequired,
    isEnableDeliveryFee: PropTypes.bool.isRequired,
    defaultDeliveryFee: PropTypes.number.isRequired,
    deliveryFeeOrdered: PropTypes.bool.isRequired,

    formatMessage: PropTypes.func.isRequired,
  };

  static defaultProps = {
    data: [],
  };

  render() {
    const { isPublic, isConsumer, isRestaurant, isDistributor, isFarmer, currentUser } = this.context;
    const {
      data,
      defaultDiscount,
      isEnableDeliveryFee,
      defaultDeliveryFee,
      deliveryFeeOrdered,
      formatMessage,
    } = this.props;

    const isConsumer2 = isConsumer || (!isRestaurant && !isFarmer && !isDistributor);
    const isCurrentUser = !isEmpty(currentUser);
    const deliveryFee = (isConsumer2 && !isEnableDeliveryFee) ? 0 : (deliveryFeeOrdered ? 0 : defaultDeliveryFee);
    const discountRate = (100 - defaultDiscount) / 100;
    let gross = 0;

    if (data.length) {
      data.forEach((item) => {
        gross += item.qty * item.price;
      });
    }

    return (
      <div className="bottom-panel" style={{margin: isConsumer || isPublic ? 0 : "" }}>
        <div className="view-discount amount-section">
          <div className="amount-panel">
            <div className="label">
              <span className="normal">
                {formatMessage((isConsumer || isPublic) ? 'GROSS TOTAL' : 'Total')}:
              </span>
            </div>
            <div className="value-text">
              <span
                className="gross-total"
                style={totalDueColStyle}
              >
                ${formatPrice(gross)}
              </span>
            </div>
          </div>
          {defaultDiscount > 0 && (
            <div className="amount-panel">
              <div className="label">
                <span className="normal">
                  {formatMessage('DISCOUNT')}
                </span>
                <span
                  className="discount"
                  style={{
                    alignItems: 'center',
                    display: 'inline-flex',
                    paddingLeft: 9,
                  }}
                >
                  {defaultDiscount || 0}%:
                </span>
              </div>
              <div className="value-text">
                <span className="red" style={totalDueColStyle}>
                  -${formatPrice(((gross * defaultDiscount) / 100).toFixed(2))}
                </span>
              </div>
            </div>
          )}
          {(!isConsumer && isCurrentUser && deliveryFee > 0) && (
            <div className="d-flex justify-content-start align-items-center">
              <span>
                {formatMessage('DELIVERY FEE')}:
              </span>
              <div style={{ width: 10 }}>
                $
              </div>
              <FRInput
                disabled
                defaultValue={deliveryFee.toFixed(2)}
                inputProps={{ style: { textAlign: 'right' } }}
                style={{
                  display: 'inline',
                  fontSize: 13,
                  overflow: 'hidden',
                  width: 60,
                }}
                type="number"
              />
            </div>
          )}
          {((isConsumer || !isCurrentUser) && isEnableDeliveryFee && deliveryFee > 0) && (
            <div className="d-flex justify-content-start align-items-center red amount-panel">
              <div className="label">
                <span>
                  {formatMessage('DELIVERY FEE')}:
                </span>
              </div>
              <div className="value-text">
                <span style={{ color: 'black' }}>
                  ${deliveryFee.toFixed(2)}
                </span>
                {/* <FRInput
                  disabled
                  defaultValue={deliveryFee.toFixed(2)}
                  inputProps={{ style: { textAlign: 'center', color: 'black' } }}
                  style={{
                    display: 'inline',
                    fontSize: 13,
                    overflow: 'hidden',
                    width: 60,
                  }}
                  type="number"
                /> */}
              </div>
            </div>
          )}
          <div
            style={{
              width:275,
              height: 1,
              color: 'gray',
              alignItems: 'center',
              borderBottom: '1px solid lightgray',
            }}>
          </div>
          <div className="amount-panel">
            <div className="label">
              <span className="normal" style={{ fontSize: '18px' }}>
                <b>{formatMessage('Total Due')}:</b>
              </span>
            </div>
            <div className="value-text">
              <span
                className="totalDue"
                style={totalDueColStyle}
                >
                <b>${formatPrice(((gross * discountRate) + deliveryFee).toFixed(2))}</b>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  setDisplayName('BottomPanel'),
  injectIntl,
)(BottomPanel);
